"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_cookie_1 = __importDefault(require("js-cookie"));
class CookieStorageService {
    get length() {
        return Object.keys(js_cookie_1.default.get()).length;
    }
    clear() {
        Object.keys(js_cookie_1.default.get()).forEach(key => js_cookie_1.default.remove(key));
    }
    getItem(key) {
        let result = js_cookie_1.default.get(key);
        return result ? result : "";
    }
    key(index) {
        throw new Error("Method not implemented.");
    }
    removeItem(key) {
        js_cookie_1.default.remove(key);
    }
    setItem(key, value, expiration) {
        let settings = {
            secure: true
        };
        if (expiration) {
            settings.expires = expiration;
        }
        js_cookie_1.default.set(key, value, settings);
    }
}
exports.CookieStorageService = CookieStorageService;
//# sourceMappingURL=CookieStorageService.js.map